import { RespuestaLecturaError } from '../Mensajes';
import { llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from '../SQL';
import { TratamientoDeParametroParaURI } from '../Varios';

export const function_PRO_Articulos_BOM_Listar = async (Where) => {
    const NombreFuncion = "function_PRO_Articulos_BOM_Listar"

    try {        
        const resulData = await llamadaAPI_GET("PRO_Articulos_BOM/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" + 
            await TratamientoDeParametroParaURI(Where));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_PRO_Articulos_BOM_LeerNecesidadesDeProduccion = async (CodigoArticulo, CodigoTamano, CodigoPresentacion, CodigoUnidadMedida, Where) => {
    const NombreFuncion = "function_PRO_Articulos_BOM_LeerNecesidadesDeProduccion"

    try {        
        const resulData = await llamadaAPI_GET("PRO_Articulos_BOM/LeerNecesidadesDeProduccion/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" + 
            await TratamientoDeParametroParaURI(CodigoArticulo) + "/" + 
            await TratamientoDeParametroParaURI(CodigoTamano) + "/" + 
            await TratamientoDeParametroParaURI(CodigoPresentacion) + "/" + 
            await TratamientoDeParametroParaURI(CodigoUnidadMedida) + "/" + 
            await TratamientoDeParametroParaURI(Where));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_PRO_Articulos_BOM_Generar_JSON = async (CodigoArticuloPadre, 
    CodigoPresentacionPadre, CodigoTamanoPadre, CodigoUnidadMedidaPadre, 
    CodigoArticuloHijo, 
    CodigoPresentacionHijo, CodigoTamanoHijo, CodigoUnidadMedidaHijo, 
    Cantidad, CodigoTipoProfesional, Intervalo, DiasDelay) => {
    const NombreFuncion = "function_PRO_Articulos_BOM_Generar_JSON";

    try {
        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            CodigoArticuloPadre: CodigoArticuloPadre,
            CodigoPresentacionPadre: CodigoPresentacionPadre,
            CodigoTamanoPadre: CodigoTamanoPadre,
            CodigoUnidadMedidaPadre: CodigoUnidadMedidaPadre,
            CodigoArticuloHijo: CodigoArticuloHijo,
            CodigoPresentacionHijo: CodigoPresentacionHijo, 
            CodigoTamanoHijo: CodigoTamanoHijo,
            CodigoUnidadMedidaHijo: CodigoUnidadMedidaHijo,
            Cantidad: Cantidad,
            CodigoTipoProfesional: CodigoTipoProfesional,
            Intervalo, Intervalo, 
            DiasDelay: DiasDelay,
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_PRO_Articulos_BOM_Insertar = async (BOM) => {
    const NombreFuncion = "function_PRO_Articulos_BOM_Insertar";

    try {
        const reciboResult = await llamadaAPI_POST("PRO_Articulos_BOM/Insertar/", BOM);
        return reciboResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_PRO_Articulos_BOM_Eliminar = async (IdItem) => {
    const NombreFuncion = "function_PRO_Articulos_BOM_Eliminar";

    try {
        await llamadaAPI_PUT("PRO_Articulos_BOM/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" + 
            IdItem);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_PRO_Articulos_BOM_CalcularCostoDeFabricacionDeArticulos = async () => {
    const NombreFuncion = "function_PRO_Articulos_BOM_CalcularCostoDeFabricacionDeArticulos"

    try {        
        const resulData = await llamadaAPI_GET("PRO_Articulos_BOM/CalcularCostoDeFabricacionDeArticulos/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};